/**
 * Created by r4zi4l on 20.08.2021
 */

Families.initialize = function () {
    Object.assign(FamiliesIds, {
        wands: 27,
        coins: 28,
        rubies: 29,

        worker: 30,
        crystal: 31,

        energy: 287,

        treasure: 13,

        multiCellBody: 54,
        thirdelement: 55,
        unknown: 148,

        advgift: 671,
        advflower: 672,
        advpalmtree: 673,
        advchest: 674,
        // adv2customerbridge1: 676, // unused
        // adv2producer0: 677, // unused
        // adv2customermain0: 678, // unused
        // adv2customermain1: 679, // unused
        // adv2customermain2: 680, // unused
        advpile: 681,
        advrush: 682,
        // adv2customermain3: 683, // unused
        advcustomermain1: 684,
        advfireplace: 685,
        advshrub: 686,
        advrock: 687,
        advdynamite: 688,
        advlawn: 689,
        // adv2customermain5: 690, // unused
        // adv2customermain6: 691, // unused
        advbush: 692,
        // adv2customermain7: 693, // unused
        // adv2customerbridge0: 694, // unused
        // adv2customermain4: 695, // unused
        // advbush7: 699, // unused
        advtree: 700,
        // advtree1: 701, // unused
        // advtree2: 702, // unused
        // advtree3: 703, // unused
        // advtree4: 704, // unused
        advcustomerbridge1: 705,
        advcustomerbridge2: 706,
        advcustomermain2: 707,
        // advdoubloon: 708, // unused
        // advclover: 709, // unused
        // advgrass: 710, // unused
        // advlog: 711, // unused
        // advseashell: 712, // unused
        // advstick: 713, // unused
        // advstone: 714, // unused
        advcustomerbridge0: 715,

        seabattlepass1: 718,
        seabattlepass2: 719,
        seabattlepass3: 720,
        seabattlepass4: 721,
        seabattlepass5: 722,

        kingfood: 728,
        // dr2dragoncup: 729, // unused
        dwarffood: 730,

        rpcustomermain0: 731,
        rpcustomermain1: 732,
        rpcustomermain2: 733,
        rpcustomermain3: 734,
        rpcustomermain4: 735,

        unitsshop: 736,

        advgenerator0: 737,
        advgenerator1: 738,
        advgenerator2: 739,

        leaf: 740,
        leafchest: 741,
        leafsource: 742,
        leafgenerator: 743,

        adv3rpcustomermain0: 744,
        adv3rpcustomerbridge0: 745,
        adv3rpproduct0: 746,
        adv3rpproducer0: 747,
        adv3rpcustomermain1: 748,
        adv3rpcustomerbridge1: 749,
        adv3rpproduct1: 750,
        adv3rpproducer1: 751,
        adv3rpcustomermain2: 752,
        adv3rpcustomerbridge2: 753,
        adv3rpproduct2: 754,
        adv3rpproducer2: 755,
        adv3rpcustomermain3: 756,
        adv3rpcustomerbridge3: 757,
        adv3rpproduct3: 758,
        adv3rpproducer3: 759,
        adv3rpcustomermain4: 760,
        adv3rpcustomerbridge4: 761,
        adv3rpproduct4: 762,
        adv3rpproducer4: 763
    });

    Families.coins = FamiliesHelper.ValuableFamily("coins", {
        amounts: [0, 1, 3, 10, 30, 90, 270, 810, 2430, 7300, 21900, 65700, 197100],
        collectible: true,
        shineFrom: 4,
        expeditions: "all"
    });
    Families.rubies = FamiliesHelper.ValuableFamily("rubies", {
        amounts: [0, 2, 6, 20, 60, 180, 540, 1620, 4860, 14580],
        collectible: true,
        shineFrom: 2,
        expeditions: "all"
    });

    Families.energy = FamiliesHelper.ValuableFamily("energy", {
        amounts: [3, 10, 30],
        collectible: true,
        expeditions: []
    });

    Families.multiCellBody = FamiliesHelper.SpecialUnitFamily({}, {
        expeditions: "all"
    });

    Families.thirdelement = FamiliesHelper.ThirdElementUnitFamily({ expeditions: "all" });

    Families.unknown = FamiliesHelper.SpecialUnitFamily({
        unmergeable: true,
        movable: false
    }, {
        expeditions: "all"
    });

    Families.treasure = FamiliesHelper.ChestFamily("treasure", {
        price: [7, 18, 40],
        extraBundles: "all"
    });

    Families.crystal = FamiliesHelper.CustomFamily(4, "custom", {
        price: [3, 20, 131, 195],
        shine: true,
        draggable: true,
        expeditions: "all",
        extraBundles: "all"
    });

    if (typeof AdventureFamilies !== "undefined") {
        AdventureFamilies.register();
    }

    Families.afterInitialize();
};

if (typeof cc === "undefined") {
    module.exports = Families;
}
